// extracted by mini-css-extract-plugin
export default {"skillsProfileGraph":"skills_profile_section___skillsProfileGraph___c56fa0ee"};